import { useEffect, useState } from 'react';
import { clienteApi } from '../../common/axios';

function euro(v) {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v || 0);
}

export default function CodiceAmicoCard() {
  const [stats, setStats] = useState(null);
  const [rules, setRules] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    Promise.all([
      clienteApi.get('/cliente/codice-amico'),
      clienteApi.get('/cliente/referral-rules'),
    ])
      .then(([sRes, rRes]) => {
        setStats(sRes.data.data);
        setRules(rRes.data.regole);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCopy = () => {
    if (stats?.link_invito) {
      navigator.clipboard.writeText(stats.link_invito);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (loading) return <div className="p-4 text-center">Caricamento codice amico...</div>;
  if (!stats) return <div className="p-4 text-center">Codice amico non disponibile</div>;

  return (
    <div className="mang-card p-6 border-2 border-[#f3deb8]">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h3 className="font-bold text-lg mb-1">Il tuo Codice Amico</h3>
          <p className="text-sm text-gray-600">Condividilo per guadagnare credito piattaforma</p>
        </div>
        <div className="text-center bg-[#fff8ea] px-4 py-2 rounded-xl">
          <p className="text-xs text-gray-500 uppercase tracking-wide">Codice</p>
          <p className="font-mono font-bold text-xl text-[#c78244]">{stats.codice}</p>
        </div>
      </div>

      <div className="bg-gray-50 rounded-xl p-4 mb-6 flex gap-4 items-center justify-between">
        <div className="truncate text-sm text-gray-600 font-mono flex-1">
          {stats.link_invito}
        </div>
        <button
          onClick={handleCopy}
          className="bg-[#c78244] text-white px-4 py-2 rounded-lg text-sm font-medium shrink-0 hover:bg-[#a66a35] transition"
        >
          {copied ? 'Copiato!' : 'Copia Link'}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div className="border rounded-xl p-3 text-center">
          <p className="text-2xl font-bold text-[#c78244]">{stats.clienti_invitati}</p>
          <p className="text-xs text-gray-500">Clienti invitati</p>
        </div>
        <div className="border rounded-xl p-3 text-center">
          <p className="text-2xl font-bold text-[#c78244]">{stats.produttori_invitati}</p>
          <p className="text-xs text-gray-500">Produttori invitati</p>
        </div>
        <div className="border rounded-xl p-3 text-center col-span-2 md:col-span-1">
          <p className="text-2xl font-bold text-green-600">{euro(stats.totale_guadagnato)}</p>
          <p className="text-xs text-gray-500">Credito generato</p>
        </div>
      </div>

      {rules && (
        <div className="text-sm text-gray-600 space-y-2 pt-4 border-t">
          <p>🎁 <strong>{rules.perc_primo_ordine}%</strong> {rules.testo_primo_ordine}</p>
          <p>🤝 <strong>{rules.perc_rolling_produttore}%</strong> {rules.testo_produttore}</p>
        </div>
      )}
    </div>
  );
}
